import { TrackType } from '@/player-config/src/types/Track/Type';
import { TextElement } from '@/player-config/src/types/RemotionPlayerConfigTypes/Element/TextElement';
import { Clip } from '@/player-config/src/types/clip-types';

export const getTextElementById = (clipData: Clip, textElementId: string): TextElement => {
  return clipData.asset_metadata.player_config?.playerConfig.tracks
    .filter(track => track.type === TrackType.ELEMENTS)
    .flatMap(track => track.elements)
    .find(element => element.id === textElementId) as TextElement;
};
